export interface IObjectWithId {
  id: string;
}

export const filterByIds = <T extends IObjectWithId>(ids: string[], objects: T[]) => {
  return ids.map((id) => objects.find((object) => object.id === id)).filter((obj) => !!obj) as T[];
};
